/**
 * Public landing / welcome page.
 *
 * The landing is a fully standalone HTML document (own <head>, fonts, global
 * CSS and inline JS) shipped as a static asset at /welcome/index.html. We embed
 * it in a full-screen iframe so its global styles can't collide with the app,
 * and so the URL stays a clean /welcome handled by the SPA router (a bare
 * /welcome/ would otherwise fall through to the login redirect in dev).
 *
 * The landing's CTA navigates window.top, so pressing it breaks out of the
 * iframe and opens the Telegram chat in the whole tab.
 */
export function WelcomePage() {
  return (
    <iframe
      src="/welcome/index.html"
      title="onlymind"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  );
}
